import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export var PageTitle = function (_a) {
    var title = _a.title;
    return (React.createElement("div", null,
        React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true }, "".concat(title).toUpperCase())));
};
